import { render, staticRenderFns } from "./upgrade_stat.vue?vue&type=template&id=b0db92d0&scoped=true&"
import script from "./upgrade_stat.vue?vue&type=script&lang=js&"
export * from "./upgrade_stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0db92d0",
  null
  
)

export default component.exports